import { customSeriesDefaultOptions } from "@/plugin/lightweight_dev.js";

export const defaultOptions = {
  ...customSeriesDefaultOptions,
  highLineColor: "transparent",
  lowLineColor: "transparent",
  closeLineColor: "transparent",
  areaBottomColor: "rgba(242, 54, 69, 0.2)",
  areaTopColor: "rgba(4, 153, 129, 0.2)",
  highLineWidth: 2,
  lowLineWidth: 2,
  closeLineWidth: 0,
};

export const HLCAreaSeriesOptions = {
  ...customSeriesDefaultOptions,
  highLineColor: "transparent",
  lowLineColor: "transparent",
  closeLineColor: "transparent",
  areaBottomColor: "rgba(242, 54, 69, 0.2)",
  areaTopColor: "rgba(4, 153, 129, 0.2)",
  highLineWidth: 2,
  lowLineWidth: 2,
  closeLineWidth: 0,
};
